import React from 'react';

import CustomerProfileDetail from './detail';
import { LinearProgress } from '@mui/material';

export default function CustomerProfileContainer({ originalAddress }) {
  return (
    <React.Suspense fallback={<LinearProgress />}>
      <CustomerProfileDetail originalAddress={originalAddress} />
    </React.Suspense>
  );
}
